import { api } from '../boot/axios'

const rentalService = {
  listPolicies () {
    return api.get('/rentals/policies').then(r => r.data)
  },
  getPolicy (id) {
    return api.get(`/rentals/policies/${id}`).then(r => r.data)
  },
  createPolicy (payload) {
    return api.post('/rentals/policies', payload).then(r => r.data)
  },
  updatePolicy (id, payload) {
    return api.put(`/rentals/policies/${id}`, payload).then(r => r.data)
  },
  deletePolicy (id) {
    return api.delete(`/rentals/policies/${id}`).then(r => r.data)
  },

  listBuildings (params = {}) {
    return api.get('/rentals/buildings', { params }).then(r => r.data)
  },
  getBuilding (id) {
    return api.get(`/rentals/buildings/${id}`).then(r => r.data)
  },
  createBuilding (payload) {
    return api.post('/rentals/buildings', payload).then(r => r.data)
  },
  updateBuilding (id, payload) {
    return api.put(`/rentals/buildings/${id}`, payload).then(r => r.data)
  },
  updateBuildingLayout (id, layout) {
    return api.put(`/rentals/buildings/${id}/layout`, { layout }).then(r => r.data)
  },
  deleteBuilding (id) {
    return api.delete(`/rentals/buildings/${id}`).then(r => r.data)
  },

  listUnits (params = {}) {
    return api.get('/rentals/units', { params }).then(r => r.data)
  },
  getUnitMap (params = {}) {
    return api.get('/rentals/units/map', { params }).then(r => r.data)
  },
  getUnitReport (params = {}) {
    return api.get('/rentals/units/report', { params }).then(r => r.data)
  },
  exportUnitReport (params = {}) {
    return api.get('/rentals/units/report', {
      params: { ...params, export: 'csv' },
      responseType: 'blob'
    }).then(r => r.data)
  },
  getUnit (id) {
    return api.get(`/rentals/units/${id}`).then(r => r.data)
  },
  createUnit (payload) {
    return api.post('/rentals/units', payload).then(r => r.data)
  },
  updateUnit (id, payload) {
    return api.put(`/rentals/units/${id}`, payload).then(r => r.data)
  },
  deleteUnit (id) {
    return api.delete(`/rentals/units/${id}`).then(r => r.data)
  },
  bulkGenerateUnits (payload) {
    return api.post('/rentals/units/bulk-generate', payload).then(r => r.data)
  },

  listAgreements (params = {}) {
    return api.get('/rentals/agreements', { params }).then(r => r.data)
  },
  getAgreement (id) {
    return api.get(`/rentals/agreements/${id}`).then(r => r.data)
  },
  createAgreement (payload) {
    return api.post('/rentals/agreements', payload).then(r => r.data)
  },
  updateAgreement (id, payload) {
    return api.put(`/rentals/agreements/${id}`, payload).then(r => r.data)
  },
  activateAgreement (id, payload = {}) {
    return api.post(`/rentals/agreements/${id}/activate`, payload).then(r => r.data)
  },
  endAgreement (id) {
    return api.post(`/rentals/agreements/${id}/end`).then(r => r.data)
  },
  generateAgreementInvoice (id) {
    return api.post(`/rentals/agreements/${id}/generate-invoice`).then(r => r.data)
  },
  getAgreementInvoices (id) {
    return api.get(`/rentals/agreements/${id}/invoices`).then(r => r.data)
  },
  previewRegisterCheckout (payload) {
    return api.post('/rentals/register-checkout/preview', payload).then(r => r.data)
  },
  prepareRegisterCheckout (payload) {
    return api.post('/rentals/register-checkout/prepare', payload).then(r => r.data)
  },
  prepayInvoices (agreementId, payload) {
    return api.post(`/rentals/agreements/${agreementId}/prepay-invoices`, payload).then(r => r.data)
  },
  createAgreementPortalLink (id, payload = {}) {
    return api.post(`/rentals/agreements/${id}/portal-link`, payload).then(r => r.data)
  },
  emailAgreementPortalLink (id, payload) {
    return api.post(`/rentals/agreements/${id}/portal-link/email`, payload).then(r => r.data)
  },
  smsAgreementPortalLink (id, payload) {
    return api.post(`/rentals/agreements/${id}/portal-link/sms`, payload).then(r => r.data)
  }
}

export default rentalService
